export const amphibians = [
   "African Clawed Frog",
   "American Bullfrog",
   "American Green Tree Frog",
   "American Toad",
   "Asian Painted Bullfrog",
   "Drwarf Clawed Frog",
   "European Green Toad",
   "Dumpy’s (Whites) Treefrog",
   "Fire Bellied Toad",
   "Giant Marine Toad",
   "Green-and-Black Poison Dart Frog",
   "Green Treefrog",
   "Lepard Frog",
   "Northern Leopard Frog",
   "Oriental Fire Bellied Toad",
   "Ornate Horned Frog",
   "Pacman Frog (Ornate Horned Frog)",
   "Panamanian",
   "Plains Leopard Frog",
   "Puerto Rican Crested Toad",
   "Spring Peeper Frog",
   "Surinam Toad",
   "Tomato Frog",
   "Vietnamese Moss Frog",
   "White’s Tree Frog",
   "Wyoming Toad",
]
